module.exports = __webpack_public_path__ + "static/media/4.536dbe4f.jpg";